import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CleanPowerIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 25" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M14.11 1.04a2 2 0 0 0-2.24 1.14L9.67 7.1a2.97 2.97 0 0 0-.21 1.77l-7.16 3.1a2 2 0 0 0-1.23 2.5l.38 1.19a2 2 0 0 0 2.08 1.38h.02l5.35-.55h.03L8.06 23H1a1 1 0 1 0 0 2h22a1 1 0 0 0 0-2h-7.58l-.96-4.47 2.35 1.87a2 2 0 0 0 2.8-.17l.82-.92a2 2 0 0 0 .15-2.5v-.02l-3.16-4.36a3.05 3.05 0 0 0-1.4-1.05l.86-7.76a2.01 2.01 0 0 0-1.54-2.32l-1.23-.26ZM10.08 23h3.29l-1.35-6.3a1 1 0 0 1-.02-.12l-1.03-.83a1 1 0 0 1 .02.38L10.08 23Zm3.98-12.07.84-7.57a1 1 0 0 1 .01-.09v-.01L13.68 3 11.5 7.9a.97.97 0 0 0-.07.58l.78 2.03h.01l1.85.4Zm-1.09 1.8a1 1 0 0 1-.2.41l-.75.9 6.05 4.8.05.05.83-.92-.01-.02-3.14-4.34a1 1 0 0 0-.5-.36l-2.33-.51Zm-9.91 1.09 7.08-3.08.43 1.12a1 1 0 0 0 .3.42l-1.63 1.97a.97.97 0 0 1-.53.23l-5.35.55h-.01l-.38-1.18a1 1 0 0 0 .09-.03Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default CleanPowerIcon;
